import {createSelector} from 'reselect';

export const getTerritoryFilter = ({territoryFilter}) => territoryFilter;

export const getTerritoryFilterData = createSelector(
  getTerritoryFilter,
  (territoryFilter) => territoryFilter.data,
);

export const isFetchingTerritoryFilter = createSelector(
  getTerritoryFilter,
  (userInfo) => userInfo.isFetchingTerritoryFilter,
);
